import React from 'react';
import {
  AssignmentTurnedIn,
  AutoStories,
  DesignServices,
  FactCheck,
  Mic,
  Print,
  UploadFile,
} from '@mui/icons-material';

export const reviewCommentStatuses = ['all', 'open', 'resolved', 'dismissed'];

export const artifactTypes = [
  { value: 'story_document', label: 'Story Document' },
  { value: 'audio', label: 'Audio' },
  { value: 'video', label: 'Video' },
  { value: 'photo', label: 'Photo' },
  { value: 'text', label: 'Text' },
  { value: 'document', label: 'Document' },
  { value: 'other', label: 'Other' },
];

export const workflowStages = [
  { key: 'artifacts', label: 'Artifacts', icon: <UploadFile />, status: 'foundation' },
  { key: 'interviews', label: 'Interviews', icon: <Mic />, status: 'planned' },
  { key: 'transcripts', label: 'Transcripts', icon: <FactCheck />, status: 'queued' },
  { key: 'story', label: 'Story', icon: <AutoStories />, status: 'waiting' },
  { key: 'reviews', label: 'Reviews', icon: <AssignmentTurnedIn />, status: 'waiting' },
  { key: 'design', label: 'Design', icon: <DesignServices />, status: 'waiting' },
  { key: 'publishing', label: 'Publishing', icon: <Print />, status: 'waiting' },
];

export const formatFileSize = (fileSize?: number | null) => {
  if (!fileSize) {
    return 'Not recorded';
  }
  if (fileSize < 1024) {
    return `${fileSize} B`;
  }
  if (fileSize < 1024 * 1024) {
    return `${(fileSize / 1024).toFixed(1)} KB`;
  }
  return `${(fileSize / (1024 * 1024)).toFixed(1)} MB`;
};
